export default __webpack_public_path__ + "31af5202b48eb6f853f3963d6172f8bb.png";